import { Component, ElementRef, inject, input, output, ViewChild } from '@angular/core';

import { faPhotoFilm } from '@fortawesome/pro-regular-svg-icons';

import { NotificationLevel, NotificationsService } from '@eiq/notifications';

import { FileType, FileTypeExtension } from '@empathy/global/data';

@Component({
  selector: 'eiq-file-uploader',
  templateUrl: 'uploader.component.html',
  styleUrls: ['uploader.component.scss']
})
export class UploaderComponent {
  @ViewChild('fileDropRef', { static: false }) fileDropEl: ElementRef;

  acceptedTypes = input<FileType[]>([FileType.ImagePng, FileType.ImageGif, FileType.ImageJpeg, FileType.VideoMp4, FileType.AudioMp3]);
  acceptedTypesText = input<FileTypeExtension[]>([
    FileTypeExtension.Jpg,
    FileTypeExtension.Png,
    FileTypeExtension.Gif,
    FileTypeExtension.Mp4,
    FileTypeExtension.Mp3
  ]);
  maxSize = input<number>(25); // MB
  multiple = input<boolean>(false);
  testId = input<string>();
  uploading = input<boolean>();

  uploaded = output<File>();

  faPhotoFilm = faPhotoFilm;

  private not = inject(NotificationsService);

  onFileDropped($event): void {
    this.upload($event);
  }

  fileBrowseHandler(event): void {
    this.upload(event.target.files);
    event.target.value = '';
  }

  private upload(file: FileList): void {
    for (let i = 0; i < file.length; i++) {
      const fileToUpload = file.item(i);
      if (fileToUpload) {
        this.uploadFile(fileToUpload);
      }
    }
  }

  private uploadFile(file: File): void {
    if (!!this.maxSize() && file.size > this.maxSize() * 1024 * 1024) {
      this.not.open({ level: NotificationLevel.Error, title: 'Error', message: `The file ${file.name} is too big. Max size allowed: ${this.maxSize()}MB` });
      return;
    }

    this.uploaded.emit(file);
  }
}
